import { render, staticRenderFns } from "./wholeseller.vue?vue&type=template&id=106f2fde&"
import script from "./wholeseller.vue?vue&type=script&lang=js&"
export * from "./wholeseller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports